import React from "react";
import { handleStringChange } from "./Input.helpers";
import FormField from "@ingka/form-field";
import InputField from "@ingka/input-field";

interface Props {
	onChange: (text: string) => void;
	id: string;
	dataTestid?: string;
	placeholder?: string;
	value?: string;
	label?: string;
	type?: string;
	disabled?: boolean;
	invalidKeys?: string[];
}

const Input: React.FunctionComponent<Props> = ({
	onChange,
	placeholder,
	value = "",
	label,
	type = "text",
	disabled,
	invalidKeys,
	id,
	dataTestid,
}) => {
	const [localVal, setLocalVal] = React.useState<string>("");

	React.useEffect(() => {
		setLocalVal(value);
	}, [value]);

	const onChangeValue = () => {
		if (localVal === value) return;

		onChange(localVal);
	};

	return (
		<div>
			<FormField
				fieldHelper={{
					id: `helper-msg-id-${id}`,
					msg: placeholder ? placeholder : "",
				}}
				validation={{
					msg: "Value already exists",
					type: "error",
				}}
				shouldValidate={invalidKeys?.includes(localVal) ?? false}
				valid={!invalidKeys || invalidKeys.length === 0}
			>
				<InputField
					id={id}
					label={label}
					data-testid={dataTestid}
					type={type as "text" | "password" | "number"}
					value={localVal}
					onChange={handleStringChange(setLocalVal, type)}
					onBlur={onChangeValue}
					placeholder={placeholder}
					disabled={disabled}
				/>
			</FormField>
		</div>
	);
};

export default Input;
